import { createContext, useContext, type ReactNode } from "react";

import { cn } from "@/lib/utils";
import { isBetaFeatureEnabled } from "./feature-flag";

/** 스코프 내부의 마크는 inset prop을 안 넘겨도 inset으로 렌더된다. */
const BetaFeatureInsetContext = createContext(false);

export const BetaFeatureInsetScope = ({
  children,
}: {
  children: ReactNode;
}) => (
  <BetaFeatureInsetContext.Provider value={true}>
    {children}
  </BetaFeatureInsetContext.Provider>
);

export const BetaFeatureOnly = ({
  children,
  fallback = null,
  inset,
  when = true,
}: {
  children: ReactNode;
  fallback?: ReactNode;
  inset?: boolean;
  when?: boolean;
}) => {
  if (!when) {
    return null;
  }

  if (!isBetaFeatureEnabled()) {
    return <>{fallback}</>;
  }

  return <BetaFeatureMark inset={inset}>{children}</BetaFeatureMark>;
};

export const BetaFeatureMark = ({
  children,
  className,
  inset,
}: {
  children: ReactNode;
  className?: string;
  inset?: boolean;
}) => {
  const insetFromScope = useContext(BetaFeatureInsetContext);
  const resolvedInset = inset ?? insetFromScope;

  return (
    <span
      data-beta-feature="true"
      data-beta-feature-inset={resolvedInset ? "true" : undefined}
      className={cn("beta-feature-mark", className)}
    >
      {children}
    </span>
  );
};
